import React from 'react';
import { CarouselItems } from '../HeroCarousel';

export type HeroImageProps = {
    alt?: string;
    fetchPriority?: FetchPriorityType;
    loading?: LoadingType;
} & Pick<
    CarouselItems,
    'croppedLogoUrl480' | 'croppedLogoUrl600' | 'croppedLogoUrl940'
>;

export enum LoadingType {
    eager = 'eager',
    lazy = 'lazy',
}

export enum FetchPriorityType {
    high = 'high',
    low = 'low',
}

export const HeroImage = ({
    alt,
    croppedLogoUrl480,
    croppedLogoUrl600,
    croppedLogoUrl940,
    fetchPriority,
    loading,
}: HeroImageProps) => {
    return (
        <picture data-testid="hero-image">
            <source
                srcSet={`
                    ${croppedLogoUrl480} 480w,
                    ${croppedLogoUrl600} 600w,
                    ${croppedLogoUrl940} 940w
                `}
                sizes="
                    (max-width:480px) 480px,
                    (max-width:600px) 600px,
                    940px
                "
            />
            <img
                width="600"
                height="300"
                alt={alt}
                src={croppedLogoUrl600}
                loading={loading}
                // fetchpriority does not exist on type 'DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>'
                //eslint-disable-next-line
                //@ts-ignore
                fetchpriority={fetchPriority}
                data-testid="hero-img"
            />
        </picture>
    );
};
